var map = {
	"./d10.svg": "8783",
	"./d12.svg": "4e7c",
	"./d20.svg": "8778",
	"./d4.svg": "e8dd",
	"./d6.svg": "e5d9",
	"./d8.svg": "a77e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fbc9";